const reatailmediaApi = process.env.BFF_RETAIL_MEDIA
const retailMediaApiMock = 'http://localhost:4008'

export { reatailmediaApi, retailMediaApiMock }
